<template>
  <div style="margin-bottom: 0" v-if="category">
    <template v-if="editText">
      <div class="text-xs-center" v-if="isLoading" style="padding-top: 15px; padding-bottom: 15px">
        <pulse-loader :color="$vuetify.theme.primary" :size="'15px'"></pulse-loader>
      </div>
      <div
        v-else
        class="category-name form-control"
        :class="{ 'has-error': errors.has('categoryname') }"
        style="width: 100%"
      >
        <div>
          <input
            v-validate="`excluded: ${categoryname}`"
            ref="category"
            type="text"
            name="categoryname"
            :data-vv-as="$t('Category name')"
            v-model="category.name"
            :placeholder="$t('Enter Category Name')"
          />
          <span class="text-error" v-if="errors.has('categoryname')">{{
            errors.first('categoryname')
          }}</span>
        </div>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="onCancelEditCategory">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="editCategory">{{ $t('Save') }}</v-btn>
        </div>
      </div>
    </template>
    <template v-else>
      <div style="display: flex; align-items: stretch">
        <div class="move-vertical text-xs-center">
          <slot name="move"></slot>
          <toggle-button
            :value="category.status"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeCategoryStatus"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
        </div>
        <div class="category-name text-truncate form-control ignore-elements">
          <div>{{ category.name }}</div>
        </div>
        <div class="action text-xs-right ignore-elements">
          <v-btn
            fab
            outline
            color="primary"
            small
            class="extra-small ma-1"
            v-if="!editText"
            @click="onEditCategory"
          >
            <em class="fa fa-pencil-alt" aria-hidden="true" />
          </v-btn>
          <v-btn
            fab
            outline
            color="primary"
            small
            class="extra-small ma-1"
            @click="onDeleteCategory"
          >
            <em class="fa fa-trash" aria-hidden="true" />
          </v-btn>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: ['value', 'categorylist'],
  data: function () {
    return {
      category: undefined,
      editText: false,
      isLoading: false
    }
  },
  mounted: function () {
    const vm = this

    vm.category = vm.value
    vm.cached_category = JSON.stringify(vm.value)
  },
  components: {
    PulseLoader,
    ToggleButton
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    categoryname() {
      return this.categorylist.filter((v) => v.id !== this.value.id).map((v) => v.name)
    }
  },
  methods: {
    onDeleteCategory: function () {
      let data = {
        id: this.category.id,
        pageid: this.selectedBot.pageid
      }
      this.$emit('onDelete', data)
    },
    pressEnter: function () {
      if (e.keyCode === 13) {
        this.editCategory()
      }
    },
    onCancelEditCategory: function () {
      const vm = this
      vm.category = JSON.parse(vm.cached_category)
      vm.$emit('input', vm.category)
      vm.editText = false
    },
    onEditCategory: function () {
      const vm = this
      vm.editText = true
      vm.$nextTick(function () {
        if (vm.category && vm.editText) {
          vm.$refs.category.focus()
        }
      })
    },
    editCategory: function () {
      const vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        let data = {
          name: vm.category.name,
          id: vm.category.id,
          pageid: vm.selectedBot.pageid
        }

        vm.isLoading = true
        api.putGroupConversation(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
          vm.isLoading = false
          vm.editText = false
          vm.cached_category = JSON.stringify(vm.category)
          vm.$emit('input', vm.category)
          vm.$emit('close')
        })
      })
    },
    onChangeCategoryStatus: function () {
      let status = this.category.status ? this.category.status : false
      this.$set(this.category, 'status', !status)
      let data = {
        pageid: this.selectedBot.pageid,
        id: this.category.id,
        status: this.category.status
      }
      const vm = this
      api
        .putStatusGroupConversation(data, function (error, response) {
          if (error) {
            console.error(error)
            return
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.category = this.value
        this.cached_category = JSON.stringify(this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.move-vertical {
  border-right: 1px solid #eee;
  padding: 10px;
  width: 12%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/ConversationGroupingEdit.vue